/**
 * Sidebar Layout Width enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum SIDEBAR_LAYOUT_WIDTH {
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large"
}

export type SIDEBAR_LAYOUT_WIDTH_string = keyof typeof SIDEBAR_LAYOUT_WIDTH;

export const SIDEBAR_LAYOUT_WIDTH_default = "MEDIUM";
